const baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
};

export default {
  baseStyle,
};
